import {ConnectPlatformTransparencyEndpointResponse} from '../../../generated/types';

export function fetchConnectPlatformTransparency(
  supportFetch: typeof fetch,
): Promise<ConnectPlatformTransparencyEndpointResponse> {
  return supportFetch('/api/connect-platform-transparency').then((resp) =>
    resp.json(),
  );
}
